<template>
  <v-app id="app">
    <v-toolbar color="green darken-2" height="58" dark tabs>
      <v-toolbar-title>
        <v-btn icon to="/">
          <v-icon>keyboard_backspace</v-icon>
        </v-btn>
        ShelterBelt
      </v-toolbar-title>

      <v-spacer />

      <template v-slot:extension>
        <v-tabs v-model="tab" color="green darken-2" grow>
          <v-tabs-slider color="yellow" />
          <v-tab v-for="item in tabs" :key="item.url" @change="changeTab(item)">
            {{ item.label }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-card flat>
      <v-card-text>
        <v-container grid-list-xl fluid>
          <removal-tab :url="isTab" />
        </v-container>
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
import RemovalTab from "./removal_tab";

export default {
  components: {
    RemovalTab
  },
  data() {
    return {
      tabs: [
        {
          label: "SB count",
          url: `${process.env.API_ROOT}/graph`
        },
        {
          label: "SB lenght",
          url: `${process.env.API_ROOT}/graph/length`
        },
        {
          label: "SB carbon",
          url: `${process.env.API_ROOT}/graph/carbon`
        }
      ],
      isTab: `${process.env.API_ROOT}/graph`,
      tab: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  methods: {
    changeTab(item) {
      this.isTab = item.url;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/removal.vue